var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
var React = require( 'react' );
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Helmet = require('react-helmet');
var Loader = require('react-loader');
var Link = require('react-router').Link;
var Education = require('./layout/education.jsx');
var SubNav = require('./layout/subNav.jsx');
var DownloadPdf = require('./layout/downloadPdf.jsx');
var BackButton = require('../../components/backButton.jsx');

var Disease = createReactClass({
	mixins: [PureRenderMixin],

    componentDidMount: function() {
      this.props.fetchDiseaseIfNeeded(this.props.params.name);
        this.relocateDownloadPdf();
    },

    componentDidUpdate: function(nextProps){
        this.relocateDownloadPdf();
    },

    relocateDownloadPdf: function(){
        var $downloadPdf = $('.download-pdf');
        if($downloadPdf.length && $downloadPdf.parents('.topic').length === 0){
            $('#information .topic:first-child').prepend($downloadPdf);
            $downloadPdf.css('opacity', 1);
            this.refs.subNav.reInitializeMagellan();
        }
    },

    hasDataLoaded: function(){
        return !!(this.props.disease.data && this.props.disease.data.friendlyUrl === this.props.params.name);
    },

    getName: function(educationItem){
        return educationItem.title.split(':')[0];
    },

    getContent: function(){
        var disease = this.props.disease.data;
        var mainSection = [];

        if(this.hasDataLoaded()){
            mainSection = disease.education.filter(function(item) {
                return item.topic !== 'how_common';
            });
        }

        var children = [
            <Helmet
                title={(disease.meta && disease.meta.title) || disease.title}
                meta={[{
                    name: 'description',
                    content: (disease.meta && disease.meta.description) || disease.description
                }]}
                key={0} />,
			<div className="content-header-wrapper" key={'content-header-wrapper'}>
				<div className="row content-header">
					<div className="small-12 medium-3 column back show-for-medium">
						<Link to="/education" onClick={this.props.setActiveEducationToggle.bind(null, 'DISEASES')}><span className="ion-ios-arrow-thin-left"></span> back to All Diseases</Link>
					</div>
					<div className="small-12 medium-6 column title">
						<h1>{disease.title}</h1>
					</div>
					<div className="small-12 medium-3 column provided-by">
						<p>information provided by<sup>*</sup></p>
						<p><img src="https://res.cloudinary.com/mytotalhealth/image/upload/q_auto/web/aga-logo.png" alt="AGA(American Gastroenterological Association)" /></p>
            <p className="disclaimer">*unless indicated otherwise</p>
          </div>
				</div>
			</div>,
            <div className="sub-nav-wrapper" id="sub-nav-wrapper" key={'sub-nav-wrapper'}>
                <SubNav
                   ref="subNav"
                   title={disease.title && disease.title.replace(/\?/g,'').replace(/\s+/g, '-').toLowerCase()}
                   name={disease.name}
                   education={mainSection}
                   getName={this.getName} />
           </div>,
		   <BackButton key="back-button" />,
           disease.file ? (
               <DownloadPdf
                   file={disease.file}
                   isLogin={!!this.props.auth.token}
                   authFacebook={this.props.authFacebook}
                   showModal={this.props.showModal}
                   key={2}
                   clickTracking={this.props.recordAGAEducationClick} />
           ) : null,
           <Education education={mainSection} key={3} />
        ];

        var content = (
            <Loader loaded={this.hasDataLoaded()}>
                {children}
            </Loader>
        );

        if(this.hasDataLoaded()){
            content = children;
        }

        return content;
    },

  render: function () {
    var disease = this.props.disease.data;
    return (
      <div id={disease.name ? disease.name + '-content' : ''} className="content fadeIn animated duration-750 delay-600">
                {this.getContent()}
      </div>
    );
  }
});

module.exports = Disease;



// WEBPACK FOOTER //
// ./src/common/routes/education/components/disease.jsx